(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-main-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init() {
    var form = document.getElementById('ck-cart-form');
    if (!form) return;

    form.querySelectorAll('[data-ck-cart-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-ck-cart-inc');
        var inp = form.querySelector('[data-ck-cart-qty="' + key + '"]');
        if (inp) { inp.value = (parseInt(inp.value, 10) || 0) + 1; form.submit(); }
      });
    });
    form.querySelectorAll('[data-ck-cart-dec]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-ck-cart-dec');
        var inp = form.querySelector('[data-ck-cart-qty="' + key + '"]');
        if (inp) {
          var v = Math.max(0, (parseInt(inp.value, 10) || 0) - 1);
          inp.value = v;
          form.submit();
        }
      });
    });

    // Gift attribute submits the form so Shopify stores attributes[gift]
    var giftInput = form.querySelector('[data-ck-cart-gift]');
    if (giftInput) {
      giftInput.addEventListener('change', function () { form.submit(); });
    }

    // Coupon code note toggle
    var couponBtn = form.querySelector('[data-ck-cart-coupon]');
    var couponNote = form.querySelector('[data-ck-cart-coupon-note]');
    if (couponBtn && couponNote) {
      couponBtn.addEventListener('click', function () {
        var isHidden = couponNote.hasAttribute('hidden');
        if (isHidden) couponNote.removeAttribute('hidden');
        else couponNote.setAttribute('hidden', '');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-ck-filter-drawer]');
    var backdrop = document.querySelector('[data-ck-filter-backdrop]');
    var openBtns = document.querySelectorAll('[data-ck-filter-open]');
    var closeBtns = document.querySelectorAll('[data-ck-filter-close]');
    var form = document.querySelector('[data-ck-filter-form]');

    if (!drawer || !backdrop || !form) return;

    // Hydrate hardcoded tag checkboxes (Special offers / Personalization)
    // from the current URL — Shopify-native filter.p.tag URL params.
    try {
      var urlParams = new URLSearchParams(window.location.search);
      var activeTags = urlParams.getAll('filter.p.tag');
      if (activeTags.length) {
        form.querySelectorAll('input[data-ck-tag-input]').forEach(function (inp) {
          if (activeTags.indexOf(inp.value) !== -1) inp.checked = true;
        });
      }
    } catch (e) { /* no-op */ }

    function open() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      backdrop.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.documentElement.style.overflow = '';
      window.setTimeout(function () { backdrop.hidden = true; }, 240);
    }

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Price presets fill min/max inputs in the form
    document.querySelectorAll('.ck-price-preset').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var minName = btn.getAttribute('data-min-name');
        var maxName = btn.getAttribute('data-max-name');
        var minInput = form.querySelector('input[name="' + minName + '"]');
        var maxInput = form.querySelector('input[name="' + maxName + '"]');
        if (minInput) minInput.value = btn.getAttribute('data-min') || '';
        if (maxInput) maxInput.value = btn.getAttribute('data-max') || '';
      });
    });

    // Sort select navigates with sort_by preserved alongside filters
    var sortSel = document.querySelector('[data-ck-sort-select]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Strip empty inputs before submit so URLs stay clean
    form.addEventListener('submit', function () {
      form.querySelectorAll('input[type="number"], input[type="checkbox"]').forEach(function (inp) {
        if (inp.type === 'number' && inp.value === '') inp.disabled = true;
        if (inp.type === 'checkbox' && !inp.checked) inp.disabled = true;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('.ck-product-page').forEach(function (root) {
      // Thumbs <-> hero image
      var thumbs = root.querySelectorAll('[data-ck-thumb]');
      var heros = root.querySelectorAll('[data-ck-hero]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-ck-thumb');
          thumbs.forEach(function (x) { x.classList.remove('active'); });
          heros.forEach(function (h) { h.classList.remove('active'); });
          t.classList.add('active');
          var hero = root.querySelector('[data-ck-hero="' + i + '"]');
          if (hero) hero.classList.add('active');
        });
      });

      // Hero nav arrows
      var navBtns = root.querySelectorAll('[data-ck-nav]');
      navBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-ck-nav');
          var current = root.querySelector('[data-ck-hero].active');
          if (!current) return;
          var idx = parseInt(current.getAttribute('data-ck-hero'), 10);
          var total = heros.length;
          var next = dir === 'next' ? (idx + 1) % total : (idx - 1 + total) % total;
          heros.forEach(function (h) { h.classList.remove('active'); });
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          var nextHero = root.querySelector('[data-ck-hero="' + next + '"]');
          var nextThumb = root.querySelector('[data-ck-thumb="' + next + '"]');
          if (nextHero) nextHero.classList.add('active');
          if (nextThumb) nextThumb.classList.add('active');
        });
      });

      // Tabs
      var tabs = root.querySelectorAll('[data-ck-tab]');
      var panels = root.querySelectorAll('[data-ck-panel]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-ck-tab');
          tabs.forEach(function (x) { x.classList.remove('active'); });
          panels.forEach(function (p) { p.classList.remove('active'); });
          t.classList.add('active');
          var panel = root.querySelector('[data-ck-panel="' + key + '"]');
          if (panel) panel.classList.add('active');
        });
      });

      // Quantity stepper
      var qtyInput = root.querySelector('[data-ck-qty-input]');
      var qtyDec = root.querySelector('[data-ck-qty-dec]');
      var qtyInc = root.querySelector('[data-ck-qty-inc]');
      if (qtyInput && qtyDec && qtyInc) {
        qtyDec.addEventListener('click', function () {
          var v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
          qtyInput.value = v;
        });
        qtyInc.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) + 1;
          qtyInput.value = v;
        });
      }

      // Variant picker — read variants JSON, find matching variant on click
      var variantsScript = root.querySelector('[data-ck-variants]');
      if (!variantsScript) return;
      var variants;
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
      var idInput = root.querySelector('input[name="id"]');
      var addBtn = root.querySelector('.ck-pdp-add');
      var addText = root.querySelector('[data-ck-pdp-add-text]');
      var priceNow = root.querySelector('.ck-pdp-price-now');
      var priceWas = root.querySelector('.ck-pdp-price-was');
      var saveBadge = root.querySelector('.ck-pdp-save-badge');
      var stockEl = root.querySelector('.ck-pdp-stock');
      var optionEls = root.querySelectorAll('.ck-pdp-select');
      var moneyFormat = (root.getAttribute('data-money-format') || '${{amount}}').replace(/<[^>]*>/g, '');

      function fmt(cents) {
        function withDecimals(sep) { return (cents / 100).toFixed(2).replace('.', sep); }
        function noDecimals() { return Math.round(cents / 100).toString(); }
        return String(moneyFormat).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
          switch (name) {
            case 'amount_with_comma_separator': return withDecimals(',');
            case 'amount_no_decimals': return noDecimals();
            case 'amount_no_decimals_with_comma_separator': return noDecimals();
            default: return withDecimals('.');
          }
        });
      }

      function getSelected() {
        var selected = [];
        optionEls.forEach(function (el) { selected.push(el.value || null); });
        return selected;
      }

      function findVariant(selected) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function update() {
        var selected = getSelected();
        var allChosen = selected.every(function (s) { return s; });
        var v = allChosen ? findVariant(selected) : null;

        if (addBtn) {
          if (!v) {
            addBtn.setAttribute('disabled', '');
            if (addText) addText.textContent = 'Sélectionnez une option';
          } else if (v.available) {
            addBtn.removeAttribute('disabled');
            if (addText) addText.textContent = 'Ajouter au panier';
            if (stockEl) {
              stockEl.textContent = 'En stock · expédié sous 1 à 2 jours ouvrés';
              stockEl.classList.remove('ck-pdp-stock--out');
            }
          } else {
            addBtn.setAttribute('disabled', '');
            if (addText) addText.textContent = 'Rupture de stock';
            if (stockEl) {
              stockEl.textContent = 'Rupture de stock — soyez prévenu du réapprovisionnement';
              stockEl.classList.add('ck-pdp-stock--out');
            }
          }
        }

        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = fmt(v.price);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = fmt(v.compare_at_price);
            priceWas.style.display = '';
            if (saveBadge) {
              var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
              saveBadge.textContent = 'SAVE ' + pct + '%';
              saveBadge.style.display = '';
            }
          } else {
            priceWas.style.display = 'none';
            if (saveBadge) saveBadge.style.display = 'none';
          }
        }
      }

      optionEls.forEach(function (el) {
        el.addEventListener('change', update);
      });
      update();

      // Popovers — toggle on click, close on outside click + Escape
      var triggers = root.querySelectorAll('[data-ck-popover-trigger]');
      triggers.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var id = btn.getAttribute('data-ck-popover-trigger');
          var pop = document.getElementById(id);
          if (!pop) return;
          var isOpen = pop.getAttribute('data-open') === 'true';
          // Close all popovers first
          root.querySelectorAll('.ck-pdp-popover[data-open="true"]').forEach(function (p) {
            p.setAttribute('data-open', 'false');
            p.setAttribute('hidden', '');
          });
          root.querySelectorAll('[data-ck-popover-trigger]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            pop.setAttribute('data-open', 'true');
            pop.removeAttribute('hidden');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
      // Close on outside click
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-ck-popover-trigger]')) return;
        if (e.target.closest('.ck-pdp-popover')) return;
        root.querySelectorAll('.ck-pdp-popover[data-open="true"]').forEach(function (p) {
          p.setAttribute('data-open', 'false');
          p.setAttribute('hidden', '');
        });
        root.querySelectorAll('[data-ck-popover-trigger]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          root.querySelectorAll('.ck-pdp-popover[data-open="true"]').forEach(function (p) {
            p.setAttribute('data-open', 'false');
            p.setAttribute('hidden', '');
          });
          root.querySelectorAll('[data-ck-popover-trigger]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
